module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-th-TH.2fe702fa.jpg";